export default {
  references: {
    title: "Spécifications techniques",
    description: "Ci-dessous la spécification technique de ce produit",
  },
  unavailable: "Ce produit n'est pas disponible à l'achat pour le moment.",
  "supplier-listings": {
    form: {
      reserve: "Faire une réservation",
      rfq: "Demander un devis",
      checkout: "Acheter maintenant",
      "sign-up": "Inscrivez-vous ici",
      "sign-in": "Se connecter",
    },
  },
  card: {
    unavailable: "Indisponible",
    "add-to-cart": "Fiche produit",
    purchase: "Achat",
    pro: "Pro",
    "product-category": {
      ADMINISTRATION: "Administration",
      DIGITAL_SALES_TOOLS: "Commercialisation",
      HARDWARE: "Matériel",
      LARGE_PRODUCER_ADMINISTRATION: "Grands producteurs",
    },
    supplierListing: {
      noOfferAvailableTitle: "Aucune offre disponible",
      noOfferAvailableText: "Aucune offre disponible",
      pcs: "pcs",
      frameType: "Type de cadre",
      type: "Type",
      power: "Puissance",
      numberOfPhases: "Nombre de phases",
      ratedPower: "Puissance nominale",
      microInverter: "Micro-inverter",
      nominalCapacity: "Capacité nominale",
      nominalVoltage: "Tension nominale",
      perUnit: "/unité",
      learnMore: "Savoir plus",
      signUpToSeePrices: "Inscrivez-vous pour voir les prix",
      deliveryTime: "2-5 jours de livraison",
      seeOffers: "Voir les offres",
      unitPrice: "Prix unitaire",
      unavailable: "indisponible",
      noOfferAvailable: "Aucune offre disponible",
    },
  },
  preview: {
    "in-stock-ready-to-ship": "En stock et prêt à être utilisée",
    "out-of-stock": "En rupture de stock",
    "product-information": "Informations sur le produit",
    "view-full-details": "Voir les détails",
    unavailable: "Indisponible",
    reviews: "revues",
    "out-of-5-stars": "sur 5 étoiles",
    "product-options": "Options du produit",
    quantity: "Quantité",
    "how-to-use":
      "Voulez-vous en savoir plus sur fonctionnement de cette prestation ?",
    button: "Ajouter au panier",
    refundable: "Remboursable",
  },
  related: {
    title: "Produits susceptibles de vous intéresser",
  },
  empty: {
    title: "Aucun produit trouvé",
    description:
      "Nous n'avons pas pu trouver de produits correspondant à votre recherche.",
  },
  "reference-information": {
    tabs: {
      productDetails: "Spécifications techniques",
      attachments: "Pièces jointes",
      downloadAllFiles: "Télécharger toutes les pièces jointes",
    },
  },
  "supplier-listing": {
    quantity: "Quantité",
    return: "Retour",
    distributedBy: "Distribué par",
    availableOffers: "Offres disponibles",
    noOfferAvailable: "Aucune offre disponible pour le moment.",
    perUnit: "/pièce",
    signUpToSeePrices: "Inscrivez-vous pour voir les prix",
    deliveryTime: "2-5 jours de livraison",
    deliveryFee: "Frais livraison",
    seeOffers: "Voir les offres",
    unitPrice: "Prix unitaire",
    available: "disponible",
    startingFrom: "à partir de",
    unavailable: "indisponible",
    pcs: "pcs",
    learnMore: "En savoir plus",
    select: "Sélectionner",

    features: {
      width: "Largeur",
      height: "Hauteur",
      length: "Longueur",
      weight: "Poids",
      power: "Puissance",
      numberOfPhases: "Nombre de phases",
      ratedPower: "Puissance nominale",
      microInverter: "Micro-inverter",
      nominalCapacity: "Capacité nominale",
      nominalVoltage: "Tension nominale",
      frameType: "Type de cadre",
      type: "Type",
      color: "Couleur",
      dimensions: "Dimensions (mm)",
      efficiencyRoundtrip: "Efficacité retour (roundtrip)",
      capacityNominal: "Capacité nominale",
      capacityUsable: "Capacité utilisable",
      depthOfDischarge: "Profondeur de décharge (DOD)",
      batteryType: "Type de batterie",
      voltageRating: "Tension nominale",
      fuseRating: "Classe de fusible",
      inputs: "Entrées",
      poles: "Pôles",
      nemaRating: "Classe NEMA",
      efficiencyMax: "Efficacité max",
      inputVoltageMax: "Tension d'entrée max",
      numInputs: "Nombre d'entrées",
      ratingStc: "Classe STC",
      weightInKgPerM2: "Poids en kg/m²",
    },

    form: {
      deliveryTime: "2-5 jours de livraison",
      deliveryFee: "Frais de livraison",
      quantity: "Quantité",
      pieces: "Pièces",
      minOfferQuantity: "Qty min de l'offre",
      expirationDate: "Date d'expiration",
      participants: "Participants",
      participantsCount: "20 personnes",
      total: "Total",
      addToCart: "Ajouter au panier",
      "request-for-quote": "Demander un devis",
      signUpToPurchase: "Inscrivez-vous <br /> pour faire un achat",
      unitPrice: "Prix unitaire",
    },
  },
  "create-product": {
    "hardware-purchase": "Achat de matèriel",
    "hardware-purchase-description": "Mettre à jour le prix pour vos matèriel.",
  },
}
